<div class="store-checkout-container" (click)="$event.stopPropagation()">
	<div class="texture-background">
		<sp-image [imageFilename]="'texture'" [altImageLabel]="'Texture background'"></sp-image>
	</div>

	<div class="logo-container">
		<sp-image [imageFilename]="'logo-name'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		<div class="logo-icon-container">
			<sp-image [imageFilename]="'logo-icon'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		</div>
	</div>

	<div class="country-image-container">
		<sp-image class="country-image-line" [imageFilename]="'curved-dash-line'" [altImageLabel]="'dash-line'"></sp-image>
		<div class="country-image-overlay"></div>
		<sp-pill class="country-name-pill" [filename]="'location-on-bkg'" [color]="'yellow'">{{
			countryName() | propertitlecase
		}}</sp-pill>
		<sp-image [imageFilename]="countryNameImage()" [isJpg]="true" [altImageLabel]="'Country image'"></sp-image>
	</div>

	<form [formGroup]="checkoutForm" class="checkout-content">
		<div class="store-checkout-selection">PAYMENT</div>

		<!-- Loading State -->
		@if (isLoadingClientSecret()) {
			<div class="loading-message">Initializing payment...</div>
		}

		<!-- Error Message -->
		<!-- @if (errorMessage()) {
			<div class="error-message">{{ errorMessage() }}</div>
		} -->

		<!-- Store Payment Element -->
		@if (clientSecret()) {
			<ngx-stripe-elements
				class="store-element-container"
				[stripe]="stripeService"
				[elementsOptions]="elementsOptions()"
			>
				<ngx-stripe-address
					class="store-address"
					[options]="billingAddressOptions()"
					(change)="onBillingAddressChange($event)"
				></ngx-stripe-address>
				<ngx-stripe-payment class="store-payment"></ngx-stripe-payment>
			</ngx-stripe-elements>
		}

		<!-- Price Breakdown -->
		@if (selectedPaymentType()) {
			<div class="price-breakdown">
				<div class="breakdown-row">
					<span class="breakdown-label">Subtotal:</span>
					<span class="breakdown-value">{{ subtotal() | currency }}</span>
				</div>
				<div class="breakdown-row">
					<span class="breakdown-label">Tax:</span>
					<span class="breakdown-value">
						@if (isCalculatingTax()) {
							<div class="tax-loading-spinner"></div>
						} @else {
							{{ tax() | currency }}
						}
					</span>
				</div>
				<div class="breakdown-row">
					<div class="breakdown-divider">&nbsp;</div>
				</div>
				<div class="breakdown-row breakdown-total">
					<span class="breakdown-label">Total:</span>
					<span class="breakdown-value">{{ total() | currency }}</span>
				</div>
			</div>
		}

		<sp-progress-dots class="store-checkout-progress" [currentStep]="1" [totalSteps]="2"></sp-progress-dots>

		<!-- Payment Error Message -->
		@if (paymentErrorMessage()) {
			<div class="payment-error-message">
				<p>{{ paymentErrorMessage() }}</p>
				<p class="payment-error-help">
					Please try again or
					<a href="mailto:support@scoutlyplans.com" class="support-link">contact support</a>
					if the problem persists.
				</p>
			</div>
		}

		<!-- Pay Now Button -->
		<div class="purchase-button-container">
			<sp-button
				class="store-checkout-purchase-btn"
				[label]="'Complete Purchase'"
				[loading]="isProcessingPayment()"
				[disabled]="
					disabled() ||
					loading() ||
					!clientSecret() ||
					isLoadingClientSecret() ||
					isProcessingPayment() ||
					checkoutForm.invalid
				"
				[formType]="'button'"
				loadingImageName="progress-activity"
				(clicked)="handleCheckout()"
			></sp-button>
		</div>
	</form>
	<sp-button class="text store-checkout-back-btn" [label]="'Go Back'" (clicked)="handleBack()"></sp-button>
</div>
